import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HeadingType } from '@freelancer/ui/heading';
import { InputSize, InputType } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import {
  FontColor,
  FontType,
  FontWeight,
  TextSize,
  TextTransform,
} from '@freelancer/ui/text';

@Component({
  selector: 'app-project-date',
  template: `
    <fl-heading
      i18n="Post Job Page form date field label"
      [flMarginBottom]="Margin.XXSMALL"
      [headingType]="HeadingType.H3"
      [size]="TextSize.MID"
    >
      When do you need this project done?
      <fl-text
        [color]="FontColor.MID"
        [fontType]="FontType.SPAN"
        [size]="TextSize.XXXSMALL"
        [textTransform]="TextTransform.UPPERCASE"
        [weight]="FontWeight.BOLD"
      >
        Optional
      </fl-text>
    </fl-heading>
    <fl-text
      i18n="Post Job Page form timezone note"
      [flMarginBottom]="Margin.SMALL"
    >
      Timezone is based on your job location.
    </fl-text>
    <fl-grid>
      <fl-col [col]="12" [colDesktopSmall]="8" [colTablet]="8">
        <fl-bit [flMarginBottom]="Margin.XLARGE">
          <fl-input
            flTrackingLabel="ProjectDate"
            [control]="control"
            [flMarginBottom]="Margin.XSMALL"
            [size]="InputSize.LARGE"
            [type]="InputType.DATE"
          ></fl-input>
        </fl-bit>
      </fl-col>
    </fl-grid>
  `,
})
export class ProjectDateComponent {
  FontColor = FontColor;
  FontType = FontType;
  FontWeight = FontWeight;
  HeadingType = HeadingType;
  InputSize = InputSize;
  InputType = InputType;
  Margin = Margin;
  TextSize = TextSize;
  TextTransform = TextTransform;

  @Input() control: FormControl;
}
